import { default as _91_46_46_46slug_93bS9up6a5ncMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/[...slug].vue?macro=true";
import { default as indexAtFMhZSNiVMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/auth/index.vue?macro=true";
import { default as indexXSheRyJXhlMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93NKSP6sGHwuMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93CoaR1HdKHEMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93cHQ095zCZGMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93qj7D1QY6dhMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/news/[slug].vue?macro=true";
import { default as organisationsGIGNEu5rCWMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsgtjZwx16M2Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsqVQ5YMowFIMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexjUYPEX5WFwMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/processes/index.vue?macro=true";
import { default as dungeonY27jFHCaHkMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsLiN7bu53urMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/secret/index/inputs.vue?macro=true";
import { default as index5IImwWPPHdMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/secret/index.vue?macro=true";
import { default as indexxvLdH2zeumMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDatajZbN6XCJ2IMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClasswwTyheajICMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_931B0kQ7qkzoMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexxWCovX7CDEMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataFgqxFZ0sfrMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFields2L34WqtWI7Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReports8xJCSGG3xEMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRights2yy46QlVBZMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93V79FxWqckfMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as index54Md2c34UbMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesXP3Cy96ex2Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatazUIXnbXatsMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93CLmTRqZpgAMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexsOMO87l4EUMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesMBfaEUcJ3RMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataZPUOXU7Mt5Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93UbXwwIqme4Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as index0qK0fz9XHPMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseData7Bmiu55yQgMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93Ysjxj7MXv0Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexYl4IYzv7eYMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataE0IDS6jAPVMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassTuUakyHOwKMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsfKP2LEYVEAMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93aseARuxXJoMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexV4kunHKr0bMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitieshOLRcirRO6Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDatadNmj3hs7lwMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodszBOF0ayJuTMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93pH9FokL0XSMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexnlDsy2AKy5Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesjawYf1xguhMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataw9PYcUsZBcMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsG9pYc5VrkTMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93aQTMnT2DbtMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as index9pQnKakcInMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataterdlxTd0GMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDataFXB5cC5VBcMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93tlYngQQsfiMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexO7AvmK5gFUMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatabzdUMOiIkFMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93m5yJDxLSmoMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexTHuHd0Qc4sMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupscZf8QnrOfMMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDataDfgCd4bCCaMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93W6ZeUofzQaMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexkNfZe7ZyKxMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parisheshlQ8PXRk1FMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesl4r1C0zhBZMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsvGBUDOJxpEMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataw0tMZRZkSIMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasxSxALcbZInMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesu4MqEX4n1rMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93zcyMdwIZSJMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as index1L8XkHG7oeMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsXIV19VIpMSMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltqcYKrZ8RApMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataOZEp7oyfwVMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsTIb22vRh0yMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_9394qSLXiiAaMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexKi42P6wyzhMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsfzjAqVcQC3Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments.vue?macro=true";
import { default as processActivities3G2Saj0glEMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataPioVuAx6SCMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_937UO5vMYnbWMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/processes/[id].vue?macro=true";
import { default as indexbawMkmbdN2Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/processes/index.vue?macro=true";
import { default as _91id_93CiyvfOI8dhMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexcI9cdLU1ClMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProviders8Di7hbeVPXMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesqBtugHEZBtMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettings2UMKwPbSxOMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatab5b2Ut6QNVMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesThJif7LROvMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptguinIRfO1XMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementQNiffue3eFMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersIO9fYCY46uMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93EjHKDRjXBYMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexJjdqZhxDAfMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsYdTEqwgCBFMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesM4PN01ZMf2Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataoAf6vURhUuMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureUclAb1am27Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93tkb1EMipi4Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexlAw4vriOL4Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersOhMAzINTV2Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users.vue?macro=true";
import { default as settings1t55xvxfF0Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesPGXIoncDQ4Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDatawGQnQUhUmfMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93bTjP3QYDXTMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexjRjAOMmoY1Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as service7WXHivDmsgMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service.vue?macro=true";
import { default as language2qi4rYYbShMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataqncqBxy7pNMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesLMyzGta9g5Meta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementEkH5AYtLxnMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersOL8q6kVscdMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93mjPWb0YGDsMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatahhTFT09fEMMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureeuy09EIHZAMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93SPF34AJolXMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/users/[id].vue?macro=true";
import { default as indexhnFEZxl4jZMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/users/index.vue?macro=true";
import { default as settingsdtIMx5HlEsMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings.vue?macro=true";
import { default as signatureAx8MGSI2eFMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/signature.vue?macro=true";
import { default as _91id_93MbsNoXbapSMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93Tib6C7eFHVMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as index6AIgmY0XgYMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93EpLrQlpAgEMeta } from "/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/wiki/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93bS9up6a5ncMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexAtFMhZSNiVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexXSheRyJXhlMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93NKSP6sGHwuMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93CoaR1HdKHEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93cHQ095zCZGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsGIGNEu5rCWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexjUYPEX5WFwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: service7WXHivDmsgMeta?.name,
    path: "/service",
    meta: service7WXHivDmsgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatabzdUMOiIkFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexxvLdH2zeumMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_931B0kQ7qkzoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexxWCovX7CDEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93V79FxWqckfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: index54Md2c34UbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93CLmTRqZpgAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexsOMO87l4EUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93UbXwwIqme4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: index0qK0fz9XHPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93Ysjxj7MXv0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexYl4IYzv7eYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93aseARuxXJoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexV4kunHKr0bMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93pH9FokL0XSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexnlDsy2AKy5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93aQTMnT2DbtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsG9pYc5VrkTMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: index9pQnKakcInMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93tlYngQQsfiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexO7AvmK5gFUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93m5yJDxLSmoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parisheshlQ8PXRk1FMeta?.name,
    path: "parishes",
    meta: parisheshlQ8PXRk1FMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93W6ZeUofzQaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsXIV19VIpMSMeta?.name,
    path: "regions",
    meta: regionsXIV19VIpMSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93zcyMdwIZSJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsfzjAqVcQC3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_9394qSLXiiAaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexKi42P6wyzhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_937UO5vMYnbWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexbawMkmbdN2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/processes/index.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settings1t55xvxfF0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProviders8Di7hbeVPXMeta?.name,
    path: "loginProviders",
    meta: loginProviders8Di7hbeVPXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93CiyvfOI8dhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexcI9cdLU1ClMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsYdTEqwgCBFMeta?.name,
    path: "organisations",
    meta: organisationsYdTEqwgCBFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93EjHKDRjXBYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexJjdqZhxDAfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersOhMAzINTV2Meta?.name,
    path: "users",
    meta: usersOhMAzINTV2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93tkb1EMipi4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexlAw4vriOL4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93bTjP3QYDXTMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexjRjAOMmoY1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsdtIMx5HlEsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93mjPWb0YGDsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93SPF34AJolXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexhnFEZxl4jZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureAx8MGSI2eFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/signature.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93MbsNoXbapSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93Tib6C7eFHVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: index6AIgmY0XgYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93EpLrQlpAgEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250430145209/client/pages/wiki/[...slug].vue")
  }
]